// extracted by mini-css-extract-plugin
module.exports = {"login":"login___hd8Xx","text":"text___OuUPO"};